import { ReactNode } from "react";

import { cn } from "@/lib/utils";

import PageHeadTitle from "@/components/Common/PageHeadTitle";

export interface PageTitleProps {
  title: string;
  className?: string;
  componentRight?: ReactNode;
  isInsidePage?: boolean;
  changePageMetadata?: boolean;
  hideTitleOnPage?: boolean;
}

export default function PageTitle({
  title,
  className = "",
  componentRight = null,
  isInsidePage = false,
  changePageMetadata = true,
  hideTitleOnPage,
}: PageTitleProps) {
  return (
    <div className={cn(!isInsidePage && "mb-2", className)}>
      {changePageMetadata && <PageHeadTitle title={title} />}

      <div
        className={cn(
          "flex min-w-0 flex-wrap items-center gap-2",
          !!componentRight && "justify-between",
        )}
      >
        <div className="flex items-center">
          {!hideTitleOnPage && (
            <h2 className="ml-0 text-xl sm:text-2xl font-semibold tracking-tight leading-tight text-slate-800">
              {title}
            </h2>
          )}
        </div>
        {componentRight}
      </div>
    </div>
  );
}
